import './georgetown3/style';
import FormStructure from './georgetown3/form_structure';

export default FormStructure;